import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { NextBestActionCardComponent } from './next-best-action-card.component';
import { ReplacePipe } from './replace.pipe';

@NgModule({
  declarations: [
    NextBestActionCardComponent,
    ReplacePipe
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  exports: [
    NextBestActionCardComponent
  ]
})
export class NextBestActionModule {}
